document.addEventListener("DOMContentLoaded", function() {
    let columnFooter = document.querySelector('.shopify-section-group-footer-group .multicolumn');
    if (columnFooter) {
        const carousel = columnFooter.querySelector('ul');
        carousel.classList.add('swiper-wrapper'); // Add Swiper wrapper class

        // Remove grid-related classes while keeping the swiper-wrapper class
        const gridClasses = Array.from(carousel.classList).filter(cls => cls.startsWith('grid--'));
        gridClasses.forEach(cls => carousel.classList.remove(cls));

        const items = carousel.querySelectorAll('li');
        items.forEach(item => item.classList.add('swiper-slide')); // Add Swiper slide class to each item

        // Create Swiper container and navigation elements
        const swiperContainer = document.createElement('div');
        swiperContainer.className = 'swiper-container';
        swiperContainer.style.position = 'relative'; // Set position to relative
        swiperContainer.style.overflow = 'hidden'; // Prevent overflow
        carousel.parentNode.insertBefore(swiperContainer, carousel);
        swiperContainer.appendChild(carousel);

        const pagination = document.createElement('div');
        pagination.className = 'swiper-pagination';
        swiperContainer.appendChild(pagination);

        // Append navigation buttons to the container
        const nextButton = document.createElement('div');
        nextButton.className = 'swiper-button-next';
        swiperContainer.appendChild(nextButton);

        const prevButton = document.createElement('div');
        prevButton.className = 'swiper-button-prev';
        swiperContainer.appendChild(prevButton);

        // Ensure proper Swiper styling
        swiperContainer.style.width = '100%';
        carousel.style.display = 'flex'; // Ensure horizontal layout
        carousel.style.flexWrap = 'nowrap'; // Prevent wrapping of slides

        // Initialize Swiper with autoplay
        function initSwipers() {
            document.querySelectorAll('.swiper-container').forEach((swiperContainer) => {
                new Swiper(swiperContainer, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    breakpoints: {
                        970: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                    },
                    loop: true,
                    autoplay: {
                        delay: 6000, // Auto-slide every 3 seconds
                        disableOnInteraction: false, // Continue autoplay after user interaction
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                });

                swiperContainer.classList.add('loaded');
                swiperContainer.parentElement.classList.add('swiper-loaded');
            });
        }

        // Call the function to initialize Swipers
        initSwipers();
    }
});